/** Portuguese formatting, in one place so the whole app is consistent. */

const MESES = ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho',
  'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'];

const DIAS_SEMANA = ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado'];

export const nomeMes = (indice: number) => MESES[indice - 1] ?? '';
export const nomeDiaSemana = (indice: number) => DIAS_SEMANA[indice] ?? '';

/** '2026-07' -> 'julho de 2026' */
export function mesPorExtenso(mes: string): string {
  const [ano, mesNum] = mes.split('-');
  return `${nomeMes(Number(mesNum))} de ${ano}`;
}

/** '2026-07-25' -> '25/07' or '25/07/2026' */
export function dataCurta(data: string, comAno = false): string {
  const [ano, mes, dia] = data.split('-');
  return comAno ? `${dia}/${mes}/${ano}` : `${dia}/${mes}`;
}

export const horas = (valor: number | null | undefined) =>
  valor === null || valor === undefined ? '—' : `${valor.toFixed(2)}h`;

export const km = (valor: number | null | undefined) =>
  valor === null || valor === undefined ? '—' : `${Number(valor).toFixed(0)} km`;

/**
 * Money, always to the cent.
 *
 * There is deliberately no way to ask for fewer decimals. Summary cards used
 * to round to whole euros, so a total of 144,80 € was headlined as 145 € while
 * the row beneath it said 144,80 € — the same figure disagreeing with itself
 * on one screen. These are amounts someone is paid; the cents are the number.
 */
export function euros(valor: number | null | undefined): string {
  if (valor === null || valor === undefined) return '—';
  return new Intl.NumberFormat('pt-PT', {
    style: 'currency', currency: 'EUR',
    minimumFractionDigits: 2, maximumFractionDigits: 2,
  }).format(valor);
}

export const numero = (valor: number | null | undefined, casas = 0) =>
  valor === null || valor === undefined
    ? '—'
    : new Intl.NumberFormat('pt-PT', { minimumFractionDigits: casas, maximumFractionDigits: casas }).format(valor);

export function percentagem(valor: number | null | undefined): string {
  if (valor === null || valor === undefined) return '—';
  return `${valor > 0 ? '+' : ''}${valor.toFixed(1)}%`;
}

/** A shift whose end time is at or before its start ran past midnight. */
export const atravessaMeiaNoite = (inicio: string, fim: string) => fim <= inicio;

export const mesAtual = () => new Date().toISOString().slice(0, 7);
export const hoje = () => new Date().toISOString().slice(0, 10);

/** Default serviço number for a date: 20260725. */
export const numeroServicoDe = (data: string) => data.replaceAll('-', '');

/**
 * NIBs are stored without spaces so a search matches however they were typed,
 * but a 25-character run is unreadable and wraps mid-digit. Group in fours,
 * the way it is printed on a bank statement.
 */
export const nib = (valor: string | null | undefined) =>
  (valor ? valor.replace(/(.{4})/g, '$1 ').trim() : '—');
